import React, { useCallback, useEffect, useState } from "react";
import { Heading, Link, Empty } from "ui-components";

import { makeToast } from "@/src/components/Toast/Toast";
import {
  BlockedUserResponse,
  BlockedUserResponseEntity,
  useUserBlockUserToggle,
  useUserGetBlockedUsers,
} from "@/src/hooks/api/generated";

import MemberInfoCard from "./MemberInfoCard";

export function MyBlockMembers(): JSX.Element {
  const [blockUsersData, setBlockUsersData] = useState<BlockedUserResponse>();
  const [blockUsersList, setBlockUsersList] =
    useState<BlockedUserResponseEntity[]>();
  const { mutate: userBlockUserToggle } = useUserBlockUserToggle();
  const { mutate: fetchBlockedUsers } = useUserGetBlockedUsers();

  const getData = useCallback(() => {
    fetchBlockedUsers(
      {
        data: {
          pageSize: 3,
        },
      },
      {
        onSuccess: (data) => {
          setBlockUsersData(data);
          setBlockUsersList(data.data);
        },
      }
    );
  }, [fetchBlockedUsers, setBlockUsersData]);

  function handleUnblockMember(userId: number): void {
    userBlockUserToggle(
      {
        data: {
          userId,
        },
      },
      {
        onSuccess: () => {
          getData();
          makeToast({
            title:
              "The user has been successfully unblocked. Please note that you will need to reconnect the user to your contacts if you want to message them again.",
            intent: "success",
          });
        },
        onError: () => {
          makeToast({
            title: "Something went wrong.",
            intent: "danger",
          });
        },
      }
    );
  }

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="w-full flex flex-col gap-y-20">
      <div className="flex flex-col items-center gap-y-5">
        <Heading variant="h3">
          Blocked Members ({blockUsersData?.total})
        </Heading>
        <div className="w-[800px] flex flex-col">
          <div className="flex flex-wrap gap-2 m-auto">
            {blockUsersList?.map((user) => (
              <div key={user.id} className="w-full">
                <MemberInfoCard
                  user={user.user}
                  isBlockedMember
                  onUnBlockAccount={() => handleUnblockMember(user.user.id)}
                />
              </div>
            ))}
          </div>
          {blockUsersData?.total === 0 ? (
            <Empty text="No Blocked Members found." />
          ) : null}
          {blockUsersData?.total && blockUsersData?.total > 3 ? (
            <Link href="/connections/blocked" className="text-center mt-2.5">
              See all
            </Link>
          ) : null}
        </div>
      </div>
    </div>
  );
}
